var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkrape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.22 41.2315C36.1438 46.452 5.37406 70.5346 5.37406 70.5346C5.37406 70.5346 28.7908 38.8899 33.867 33.6694C38.9432 28.4488 69.713 4.36625 69.713 4.36625C69.713 4.36625 46.2962 36.0109 41.22 41.2315Z",
    fill: "#CCCCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8729 50.1869C47.0657 54.1023 23.9884 72.1642 23.9884 72.1642C23.9884 72.1642 41.551 48.4307 45.3581 44.5153C49.1653 40.5999 72.2426 22.5379 72.2426 22.5379C72.2426 22.5379 54.68 46.2714 50.8729 50.1869Z",
    fill: "#CCCCCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6419 30.4847C25.8347 34.4001 2.75738 52.462 2.75738 52.462C2.75738 52.462 20.32 28.7285 24.1271 24.8131C27.9343 20.8977 51.0116 2.83579 51.0116 2.83579C51.0116 2.83579 33.449 26.5693 29.6419 30.4847Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkrape);
export default __webpack_public_path__ + "static/media/skrape.38cf5de285abfa3f053967dc0e5fc2cf.svg";
export { ForwardRef as ReactComponent };